package top.wcpe.allincore.dsl.compiler.ast

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/** screen 级 `papi { ... }` 块。 */
data class PapiBlockAst(
    val placeholders: List<PapiPlaceholderAst>,
    override val position: SourcePosition,
) : AstNode

/** 单个 PlaceholderAPI short name 配置。 */
data class PapiPlaceholderAst(
    val shortName: String,
    val shortNameIsIdentifier: Boolean,
    val refreshMs: Long?,
    val bindState: String?,
    val bindExpr: ExprAst?,
    val pipe: ExprAst.LambdaExpr?,
    val pipeExpr: ExprAst?,
    val onChange: String?,
    val onChangeExpr: ExprAst?,
    override val position: SourcePosition,
) : AstNode
